import { SONG_STAFF_GROWTH, SONG_STAFF_HEIGHT_PX } from "./songViewDefaults";
import type { TimedMusicXmlNote } from "./songEngine";

/** Bloque visual del pentagrama en clave de sol (8vb en guitarra). */
export const SONG_STAFF_TREBLE_HEIGHT_PX = SONG_STAFF_HEIGHT_PX;

/** Reserva para clave de fa cuando hace falta (piano / mano izquierda). */
export const SONG_STAFF_BASS_BLOCK_PX = Math.round(168 * SONG_STAFF_GROWTH);

/** Margen vertical de la aguja respecto al bloque de pentagrama. */
export const SONG_PLAYHEAD_BLEED_PX = 12;

/** Ancho de la línea roja del playhead en canciones. */
export const SONG_PLAYHEAD_WIDTH_PX = 1.25;

export function songNeedsBassStaff(
  notes: TimedMusicXmlNote[],
  surface: "fretboard" | "keyboard"
): boolean {
  if (surface !== "keyboard") return false;
  return notes.some((n) => !n.isRest && n.midi > 0 && n.midi < 60);
}

export function songStaffViewportHeight(needsBass: boolean): number {
  return needsBass
    ? SONG_STAFF_TREBLE_HEIGHT_PX + SONG_STAFF_BASS_BLOCK_PX
    : SONG_STAFF_TREBLE_HEIGHT_PX;
}
